module.exports = __webpack_public_path__ + "static/media/dotsmenu.74ef31b9.svg";